import { render, staticRenderFns } from "./ConteudoEgressos.vue?vue&type=template&id=509825aa&scoped=true&lang=pug&"
import script from "./ConteudoEgressos.vue?vue&type=script&lang=js&"
export * from "./ConteudoEgressos.vue?vue&type=script&lang=js&"
import style0 from "./ConteudoEgressos.styl?vue&type=style&index=0&id=509825aa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509825aa",
  null
  
)

export default component.exports